module.exports = require("./kab");